import $axios from './config';

export default {
	fetchUsers(query) {
		return $axios.get(
			`/api/v2/admin/users/search${query ? '?query=' + query : ''}`
		);
	},

	fetchUser(id) {
		return $axios.get(`/api/v2/admin/users/${id}`);
	},

	fetchUsersTransactions(id) {
		return $axios.get(`/api/v2/admin/users/${id}/transactions`);
	},

	verifyUser({ id, ...payload }) {
		return $axios.put(`/api/v2/admin/users/${id}`, { ...payload });
	},

	broadcast(payload) {
		return $axios.post(`/api/v2/admin/users/broadcast`, payload);
	},

	sendBulkSMS(payload) {
		return $axios.post(`/api/v2/admin/users/broadcast`, {
			...payload,
			transport: 'SMS',
		});
	},

	createBanner(payload) {
		return $axios.post(`/api/v2/admin/banners`, payload);
	},
	deleteBanner() {
		return $axios.delete(`/api/v2/admin/banners`);
	},
	changeUsername({ id, ...payload }) {
		return $axios.put(`/api/v2/admin/users/${id}/username`, { ...payload });
	},
};
